module.exports = __webpack_public_path__ + "static/media/music_image_turquoise.e748c19f.png";